function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 8l1.5 3h-.7l1.7 3h-1l2 3h-4v4h-2v-4h-3v4h-2v-4H8v4H6v-4H2l2-3H3l1.7-3H4l1.5-3H5l2-5 2 5h-.5l1 2 1-2H10l2-5 2 5h-.5l1 2 1-2H15l2-5 2 5h-.5z",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgLocationForest(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationForest);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48ZyBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Ik0xOC41IDhsMS41IDNoLS43bDEuNyAzaC0xbDIgM2gtNHY0aC0ydi00aC0zdjRoLTJ2LTRIOHY0SDZ2LTRIMmwyLTNIM2wxLjctM0g0bDEuNS0zSDVsMi01IDIgNWgtLjVsMSAyIDEtMkgxMGwyLTUgMiA1aC0uNWwxIDIgMS0ySDE1bDItNSAyIDVoLS41eiIvPjwvZz48L2c+PC9zdmc+Cg==";
export { ForwardRef as ReactComponent };